// Validações de conta (P0.6). Senha mínima de 6 caracteres (ASM-040 — decisão do usuário).

export const MIN_PASSWORD = 6;

export type AuthFieldError = 'required' | 'invalid_email' | 'password_too_short' | 'terms_required' | 'name_too_long';

const REQUIRED: AuthFieldError = 'required';
const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

export function isValidEmail(email: string): boolean {
  return EMAIL_RE.test(email.trim());
}

export interface SignUpInput {
  name: string;
  email: string;
  password: string;
  acceptTerms: boolean;
}

/** Nome como a pessoa escreveu, sem espaços nas pontas e com a inicial maiúscula ("ana" → "Ana"). */
export function tidyName(name: string): string {
  const s = name.trim();
  return s.charAt(0).toLocaleUpperCase() + s.slice(1);
}

export function validateSignUp(input: SignUpInput): Partial<Record<'name' | 'email' | 'password' | 'terms', AuthFieldError>> {
  const e: Partial<Record<'name' | 'email' | 'password' | 'terms', AuthFieldError>> = {};
  if (!input.name.trim()) e.name = 'required';
  else if ([...input.name.trim()].length > 80) e.name = 'name_too_long';
  if (!input.email.trim()) e.email = 'required';
  else if (!isValidEmail(input.email)) e.email = 'invalid_email';
  const pw = validateNewPassword(input.password);
  if (pw) e.password = pw;
  if (!input.acceptTerms) e.terms = 'terms_required';
  return e;
}

export function validateSignIn(email: string, password: string): Partial<Record<'email' | 'password', AuthFieldError>> {
  const e: Partial<Record<'email' | 'password', AuthFieldError>> = {};
  if (!email.trim()) e.email = 'required';
  else if (!isValidEmail(email)) e.email = 'invalid_email';
  if (!password) e.password = REQUIRED;
  return e;
}

export function validateNewPassword(password: string): AuthFieldError | null {
  if (!password) return REQUIRED;
  if (password.length < MIN_PASSWORD) return 'password_too_short';
  return null;
}
